import { TriangleAlert } from "lucide-react"
import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@f2e/ui/components/base"

interface RewriteAlertDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export const RewriteAlertDialog = ({
  open,
  onOpenChange,
  onConfirm,
}: RewriteAlertDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("history.conversationFooter.rewrite.title")}
          </AlertDialogTitle>
          <div className="flex items-center text-sm text-yellow-600 dark:text-yellow-500">
            <TriangleAlert className="w-4 h-4 inline mr-1" />
            <span>{t("history.conversationFooter.rewrite.warning")}</span>
          </div>
          <AlertDialogDescription>
            {t("history.conversationFooter.rewrite.confirm")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={(e) => e.stopPropagation()}>
            {t("history.conversationFooter.actions.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t("history.conversationFooter.actions.continue")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
